<script>
import BaseLidar from '../BaseLidar'

export default {
  name: 'DataDisplayLidar',
  routeInfo: {
    label: '激光雷达',
    icon: 'fa fa-users'
  },
  extends: BaseLidar,
  computed: {
    siteDeviceCategory: () => process.env.QI_RONG_JIAO_LIDAR_DEVICE_CATEGORY
  }
}
</script>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/01Lidar/index.vue